var _mask, _g, _mask2, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDe(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 46,
    viewBox: "0 0 64 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 64,
    height: 46
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.9048 0H6.09524C2.72893 0 0 2.72893 0 6.09524V39.619C0 42.9854 2.72893 45.7143 6.09524 45.7143H57.9048C61.2711 45.7143 64 42.9854 64 39.619V6.09524C64 2.72893 61.2711 0 57.9048 0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.9048 0H6.09524C2.72893 0 0 2.72893 0 6.09524V39.619C0 42.9854 2.72893 45.7143 6.09524 45.7143H57.9048C61.2711 45.7143 64 42.9854 64 39.619V6.09524C64 2.72893 61.2711 0 57.9048 0Z",
    fill: "#F65260"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 30.4762V39.6042C0 42.9787 2.75 45.7143 6.07866 45.7143H57.9213C61.2785 45.7143 64 42.99 64 39.6042V30.4762H0Z",
    fill: "#FBCC62"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.07866 0C2.72151 0 0 2.72427 0 6.11012V15.2381H64V6.11012C64 2.73559 61.25 0 57.9213 0H6.07866Z",
    fill: "#292929"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 64,
    height: 46
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.9048 0H6.09524C2.72893 0 0 2.72893 0 6.09524V39.619C0 42.9854 2.72893 45.7143 6.09524 45.7143H57.9048C61.2711 45.7143 64 42.9854 64 39.619V6.09524C64 2.72893 61.2711 0 57.9048 0Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.1427 0.761917H6.85696C3.49065 0.761917 0.761719 3.49085 0.761719 6.85716V38.8572C0.761719 42.2235 3.49065 44.9524 6.85696 44.9524H57.1427C60.509 44.9524 63.2379 42.2235 63.2379 38.8572V6.85716C63.2379 3.49085 60.509 0.761917 57.1427 0.761917Z",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDe);
export default __webpack_public_path__ + "static/media/DE.b6d7e96f.svg";
export { ForwardRef as ReactComponent };